import { useSettings } from '../../contexts/SettingsContext';
import { MessageCircle } from 'lucide-react';

export default function FloatingWhatsApp() {
  const { businessInfo } = useSettings();
  const phone = businessInfo?.phone || '+263-71-708-2807';
  const whatsappUrl = `https://wa.me/${phone.replace(/\D/g, '')}`;

  return (
    <a
      href={whatsappUrl}
      target="_blank"
      rel="noopener noreferrer"
      className="fixed bottom-6 right-4 sm:bottom-8 sm:right-6 z-50 flex items-center justify-center w-14 h-14 rounded-full bg-[#25D366] text-white shadow-soft-lg hover:scale-110 hover:shadow-xl transition-all duration-300 focus:outline-none focus:ring-2 focus:ring-[#25D366] focus:ring-offset-2"
      aria-label="Chat on WhatsApp"
    >
      <MessageCircle size={28} />
    </a>
  );
}
